// extracted by mini-css-extract-plugin
export default {"popup":"_1UxgT4LsrrFnN2YDbFpUrP","exit":"_24WqNq70YDbRPm8f6HPIDq"};